import axios from 'axios';
import { useQuery } from 'react-query';

export default function useGetProjects() {
  const { data, isLoading, error } = useQuery(
    'projects',
    async () => {
      const fetchedData = await axios.get('/projects');
      return fetchedData.data;
    },
    {
      placeholderData: [],
    }
  );

  return {
    projects: data,
    isLoading: isLoading,
    error,
  };
}
